module.exports = __webpack_public_path__ + "img/PRINT_BOOK.FR-Slider_03.ad9c6b1c.jpg";